export const REMEMBER_ME = "rememberMe";
export const SESSION_ID = "sessionId";
